import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OrderAgent } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class OrderAgentService extends TmsWebBaseEditCreateService<OrderAgent, OrderAgent> {
  constructor() {
    super('OrderAgent', $localize`Order Agent`);
  }

  getForSalesOrderHeader(id: string): Observable<OrderAgent[]> {
    return this.httpService.get<OrderAgent[]>(`${this.apiUrl}/GetForSalesOrderHeader?id=${id}`);
  }
}
